import React from 'react';
import classnames from 'classnames';
import { ButtonLoadingIcon } from '../common/ButtonLoadingIcon';
import { ProductImageStatus } from '../../constants/productApproval';
import { LinkButton } from '../common/LinkButton';

export const ProductImage = ({
  image,
  onSetPrimary,
  onDeleteImage,
  index,
  isAllowAddImage,
}) => {
  const wrapperClassname = classnames('product-img-wrapper position-relative');

  const {
    img_url: url,
    // eslint-disable-next-line no-unused-vars
    img_primary: isPrimaryImage,
    id,
    status,
    product_id: productId,
  } = image;

  let imageUrl = url !== '' && url !== 'null' ? url : '/logo512.png';

  let isImgUploaded =
    status === ProductImageStatus.UPLOADED ||
    (productId !== undefined && isAllowAddImage);

  return (
    <div className={wrapperClassname}>
      {isImgUploaded && (
        <div className='actons-row'>
          {index === 0 ? (
            <>
              <strong>Primary</strong>
              <div
                className='glyph-icon simple-icon-close delete-image text-muted-icon'
                onClick={() => {
                  onDeleteImage(id);
                }}
              />
            </>
          ) : (
            <>
              <LinkButton
                onClick={() => {
                  onSetPrimary(id);
                }}
              >
                <span className='link-text'>Set Primary</span>
              </LinkButton>
              <div
                className='glyph-icon simple-icon-close delete-image text-muted-icon'
                onClick={() => {
                  onDeleteImage(id);
                }}
              />
            </>
          )}
        </div>
      )}

      <div className='img-wrapper'>
        <img src={imageUrl} alt='' className='product-img' loading={'lazy'} />

        {status === ProductImageStatus.UPLOADING && (
          <div className='progress-indicator'>
            <ButtonLoadingIcon />
          </div>
        )}
      </div>
    </div>
  );
};
